/* Enhancements for this page only; demos and disclosures use native HTML/CSS. */
(() => {
  'use strict';

  const root = document.getElementById('custom-apple');
  if (!root || root.dataset.appleHomeReady) return;
  root.dataset.appleHomeReady = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const headers = document.querySelectorAll(
    '#shopify-section-header, #shopify-section-header .header, ' +
    '#shopify-section-header-mobile, #shopify-section-header-mobile .header'
  );

  function headerOffset() {
    let height = 0;
    headers.forEach((header) => {
      const box = header.getBoundingClientRect();
      const style = window.getComputedStyle(header);
      if (!box.height || !box.width || style.visibility === 'hidden') return;
      // This theme pins enabled headers only after the user scrolls past them.
      // Reserve their height on the first anchor click as well.
      const configuredSticky = window.innerWidth < 992
        ? header.classList.contains('sticky-mobile-enable')
        : header.classList.contains('sticky-enable');
      if (configuredSticky) height = Math.max(height, box.height);
      if (style.position === 'fixed' || style.position === 'sticky') {
        // Sticky headers may still be below their pinned position before scrolling.
        const top = parseFloat(style.top) || 0;
        if (top >= 0 && top < window.innerHeight / 2) {
          height = Math.max(height, top + box.height);
        }
      }
    });
    const offset = Math.ceil(height) + 20;
    root.style.setProperty('--apple-anchor-offset', `${offset}px`);
    return offset;
  }

  function findTarget(hash) {
    if (!hash || hash === '#') return null;
    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (_) {
      return null;
    }
    const target = document.getElementById(id);
    return target && root.contains(target) ? target : null;
  }

  function reveal(target) {
    for (let parent = target.parentElement; parent && parent !== root; parent = parent.parentElement) {
      if (parent.tagName === 'DETAILS') parent.open = true;
    }
  }

  function navigate(hash, { smooth = false, focus = false } = {}) {
    const target = findTarget(hash);
    if (!target) return false;
    reveal(target);
    requestAnimationFrame(() => {
      if (focus) {
        const addedTabindex = !target.hasAttribute('tabindex');
        if (addedTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (addedTabindex) {
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
      }
      window.scrollTo({
        top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset()),
        behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant'
      });
    });
    return true;
  }

  root.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link || !root.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const hash = link.getAttribute('href');
    if (!findTarget(hash)) return;
    event.preventDefault();
    if (window.location.hash !== hash) history.pushState(null, '', hash);
    navigate(hash, { smooth: true, focus: true });
  });

  window.addEventListener('hashchange', () => navigate(window.location.hash));
  window.addEventListener('resize', headerOffset, { passive: true });
  headerOffset();

  // Open hidden destinations before the browser performs its initial hash scroll.
  const initialTarget = findTarget(window.location.hash);
  if (initialTarget) reveal(initialTarget);
  const initialHash = window.location.hash;
  const alignInitialHash = () => {
    if (initialHash && window.location.hash === initialHash) navigate(initialHash);
  };
  if (document.readyState === 'complete') alignInitialHash();
  else window.addEventListener('load', alignInitialHash, { once: true });
})();
